import React from "react";

import { Link } from "react-router-dom";

import { PageHeader, Descriptions, Divider, Table, Popconfirm, Button, Alert, Space, Statistic, Row } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import Moment from "moment";
import { LAYOUT_FINANCE_PURCHASE_ORDER_SHOW } from "../../../navigation";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import { AmountText } from "../../../../../core/components/widget/amountInline";

import { PurchaseOrderStatusLabel } from "../../../../../components/purchaseOrder/status";

import PropTypes from "prop-types";

const propTypes = {
    details: PropTypes.array,
    isLoading: PropTypes.bool,
    vendorName: PropTypes.string,
    downloadPurchaseOrder: PropTypes.func.isRequired,
};

const defaultProps = {
    details: [],
    isLoading: false,
    vendorName: "name",
};

const columnsAntd = (props) => {
    const { isLoading, vendorName, downloadPurchaseOrder } = props;

    if (isLoading) {
        return [];
    }

    return [
        {
            title: "PO",
            dataIndex: "purchase_order",
            key: "po.id",
            width: 120,
            render: (po, record) => <Link to={LAYOUT_FINANCE_PURCHASE_ORDER_SHOW(po?.id)}>{po?.display_id}</Link>,
        },
        {
            title: "Date",
            dataIndex: "purchase_order",
            key: "po.date",
            width: 120,
            render: (po) => {
                if (po && po.date) return <>{Moment(po.date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Status",
            dataIndex: "purchase_order",
            key: "po.code",
            width: 100,
            render: (po, record) => {
                return (
                    <Row justify="center">
                        <PurchaseOrderStatusLabel status={po.status} />
                    </Row>
                );
            },
        },

        {
            title: "Code",
            dataIndex: "purchase_order",
            key: "po.code",
            render: (po) => <>{po?.code}</>,
        },

        {
            title: "Amount",
            dataIndex: "amount_value",
            align: "right",
            key: "amountValue",
            width: 200,
            // eslint-disable-next-line react/display-name
            render: (jsa, record) => <AmountText value={record.amount_value} type={record.amount_type} />,
        },
        {
            title: "Action",
            key: "operation",
            align: "center",
            width: 100,
            render: (record) => {
                return (
                    <Button
                        style={{ margin: 0 }}
                        icon={<DownloadOutlined />}
                        size="small"
                        onClick={() =>
                            props.downloadPurchaseOrder(
                                record.purchase_order?.id,
                                `PO-${record.purchase_order?.id}_${vendorName}.xlsx`
                            )
                        }
                    />
                );
            },
        },
    ];
};

const Details = (props) => {
    const { details } = props;

    const getRowId = (row) => row.id;

    return (
        <PageHeader ghost={false} title="Details">
            <Table
                bordered={true}
                size="small"
                rowKey={getRowId}
                dataSource={details}
                columns={columnsAntd(props)}
                pagination={false}
            />
        </PageHeader>
    );
};

Details.propTypes = propTypes;
Details.defaultProps = defaultProps;

export default Details;
